var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 39,
    fill: "#FB923C",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9987 33.2502C39.5418 33.2502 39.9973 33.0662 40.3653 32.6982C40.732 32.3314 40.9154 31.8766 40.9154 31.3335C40.9154 30.7904 40.732 30.3349 40.3653 29.9669C39.9973 29.6002 39.5418 29.4168 38.9987 29.4168C38.4556 29.4168 38.0008 29.6002 37.634 29.9669C37.266 30.3349 37.082 30.7904 37.082 31.3335C37.082 31.8766 37.266 32.3314 37.634 32.6982C38.0008 33.0662 38.4556 33.2502 38.9987 33.2502ZM38.9987 58.1668C36.3473 58.1668 33.8556 57.6634 31.5237 56.6565C29.1918 55.6509 27.1633 54.2856 25.4383 52.5606C23.7133 50.8356 22.348 48.8071 21.3424 46.4752C20.3355 44.1432 19.832 41.6516 19.832 39.0002C19.832 36.3488 20.3355 33.8571 21.3424 31.5252C22.348 29.1932 23.7133 27.1647 25.4383 25.4397C27.1633 23.7147 29.1918 22.3488 31.5237 21.3419C33.8556 20.3363 36.3473 19.8335 38.9987 19.8335C41.6501 19.8335 44.1418 20.3363 46.4737 21.3419C48.8056 22.3488 50.8341 23.7147 52.5591 25.4397C54.2841 27.1647 55.6494 29.1932 56.655 31.5252C57.6619 33.8571 58.1654 36.3488 58.1654 39.0002C58.1654 41.6516 57.6619 44.1432 56.655 46.4752C55.6494 48.8071 54.2841 50.8356 52.5591 52.5606C50.8341 54.2856 48.8056 55.6509 46.4737 56.6565C44.1418 57.6634 41.6501 58.1668 38.9987 58.1668ZM38.9987 54.3335C43.2473 54.3335 46.8653 52.8404 49.8528 49.8542C52.839 46.8668 54.332 43.2488 54.332 39.0002C54.332 34.7516 52.839 31.1335 49.8528 28.1461C46.8653 25.1599 43.2473 23.6668 38.9987 23.6668C34.7501 23.6668 31.1327 25.1599 28.1465 28.1461C25.1591 31.1335 23.6654 34.7516 23.6654 39.0002C23.6654 43.2488 25.1591 46.8668 28.1465 49.8542C31.1327 52.8404 34.7501 54.3335 38.9987 54.3335Z",
    fill: "#FB923C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9154 48.5356V37.0835L37.082 37.1314V48.5835L40.9154 48.5356Z",
    fill: "#FB923C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupStatus);
export default __webpack_public_path__ + "static/media/Popup Status.85b422c5992335d3c9e8d7429a8fd014.svg";
export { ForwardRef as ReactComponent };